var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{attrs:{"id":"dashboard-analytics"}},[_c('analytics-statuses'),_c('analytics-progress-section')],1)}
var staticRenderFns = []

export { render, staticRenderFns }